import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { cn } from "@synthesis/shared-utils";

import { getDocumentKitsLabel, type ConstructorService } from "../constructor-services-page.lib";
import { ServiceStatusTag } from "./service-status-tag";

const ServiceColumn = ({ header, className, children }: { header: string; className?: string; children: ReactNode }) => (
  <div className={cn("flex shrink-0 flex-col justify-center gap-2", className)}>
    <p className="paragraph-base text-type-minor">{header}</p>
    {children}
  </div>
);

/** Карточка услуги: название с иконкой + колонки «Код / Версии процесса / Документы» + статус. Ведёт на карточку услуги. */
export const ServiceCard = ({ service }: { service: ConstructorService }) => {
  const Icon = service.icon;

  return (
    <li>
      <Link
        to="/admin/services/$id"
        params={{ id: service.id }}
        data-testid={`eacd-constructor-service-${service.id}`}
        className="bg-neutrals-white hover:border-neutrals-90 hover:bg-neutrals-99/60 border-neutrals-95 flex h-[76px] items-center justify-between gap-6 rounded-[18px] border-2 px-4 py-2 transition-colors"
      >
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <span className="text-neutrals-60 flex size-6 shrink-0 items-center justify-center">
            <Icon className="size-6" aria-hidden />
          </span>
          <div className="min-w-0 flex-1">
            <h3 className="subtitle-base text-type-common truncate">{service.title}</h3>
            <p className="paragraph-base text-type-common truncate">{service.description}</p>
          </div>
        </div>

        <ServiceColumn header="Код" className="w-[116px]">
          <p className="subtitle-sm text-additional-blue-50 truncate">{service.code}</p>
        </ServiceColumn>

        <ServiceColumn header="Версии процесса" className="w-[216px]">
          <p className="subtitle-sm text-type-common">
            {service.versions.activeLabel}
            <span className="text-type-light">, {service.versions.archivedLabel}</span>
          </p>
        </ServiceColumn>

        <ServiceColumn header="Документы" className="w-[128px]">
          <p className="subtitle-sm text-type-common">{getDocumentKitsLabel(service.documentKitsCount)}</p>
        </ServiceColumn>

        <ServiceStatusTag status={service.status} />
      </Link>
    </li>
  );
};
